export default "__VITE_ASSET__CaDfqGVM__"